import { handle } from 'redux-pack';

export const changeEnabledButton = (prevState, action) => ({
  ...prevState,
  enabledButton: action.extraProperties.enabledButton,
});

export const changeBottomButtonPayload = (prevState, action) => ({
  ...prevState,
  bottomButtonPayload: action.extraProperties.payload,
});

export const changeIsSubmitting = (state, action) =>
  handle(state, action, {
    start: prevState => ({
      ...prevState,
      isSubmitting: true,
    }),
    finish: prevState => ({
      ...prevState,
      isSubmitting: false,
    }),
  });
